import { Action } from 'redux';

import type { BootstrapStore } from 'bootstrap.store';

let store: BootstrapStore | undefined;

export const setStoreElevio = (elevioStore: BootstrapStore): void => {
  store = elevioStore;
};

const getStore = (): BootstrapStore => {
  if (!store) {
    throw new Error('Elevio store not initialized');
  }
  return store;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getElevioState = () => {
  return getStore().getState().elevio;
};

// export dispatch alias
export const dispatch = (action: Action): Action => {
  return getStore().dispatch(action);
};
